import { useQuery } from "@apollo/client/react";
import { Loader } from "@volumental/common";
import { sendEvent } from "@volumental/link";
import type React from "react";
import type { PropsWithChildren } from "react";
import { graphql } from "../api/gql";
import { GeneralErrorPage } from "../pages/error/GeneralErrorPage";
import { InitialViewProvider } from "./initial-view-provider";

const GetConfigurationQuery = graphql(`
  query getFullConfiguration {
    configuration {
      scanner {
        allowSelfScanning
        allowAssistedScanning
        supportedReferenceObjects
      }
      features {
        measurement {
          isEnabled
        }
        recommendation {
          enableSurvey
          displayFootWidth
          displayShoeSizeLabel
          isEnabled
        }
        enableProfiles
      }
      unitSystem
    }
  }
`);

export function ConfigurationProvider({ children }: PropsWithChildren): React.JSX.Element {
  const { loading, error, data, refetch } = useQuery(GetConfigurationQuery);

  if (loading) {
    return <Loader />;
  }
  if (error || !data) {
    return (
      <GeneralErrorPage
        errorText="Failed to fetch configuration"
        onClose={() => {
          sendEvent({
            type: "close",
            data: undefined,
          });
        }}
        onRestart={() => {
          void refetch();
        }}
      />
    );
  }
  return <InitialViewProvider configuration={data.configuration}>{children}</InitialViewProvider>;
}
